export default __webpack_public_path__ + "static/media/langer_bus_hinten_weiß.4a714d44.jpg";